import { JSX } from 'react';

import { Icon } from '@vk-hr-tek/ui/Icon';

import { NicknameKeys } from '../../types';

export const SIDEBAR_ICONS = (
  isActive?: boolean,
): Record<NicknameKeys, JSX.Element | null> => {
  const color = isActive ? 'text.light.secondary' : 'text.light.primary';

  return {
    main: <Icon name="home_outline" size="20" color={color} />,
    news: <Icon name="advertising_outline" size="20" color={color} />,
    company_target_audience: (
      <Icon name="advertising_outline" size="20" color={color} />
    ),
    process_catalog: (
      <Icon name="grid_4_uneven_vertical_outline" size="20" color={color} />
    ),
    surveys: (
      <Icon name="rectangle_2_horizontal_outline" size="20" color={color} />
    ),
    dropdown_social_life: (
      <Icon name="narrative_outline" size="20" color={color} />
    ),
    community: <Icon name="globe_outline" size="20" color={color} />,
    favorites: <Icon name="bookmark_outline" size="20" color={color} />,
    feed: <Icon name="globe_outline" size="20" color={color} />,
    structure: <Icon name="vkhrtek_company_page" size="20" color={color} />,
    company_events: <Icon name="globe_outline" size="20" color={color} />,
    dropdown_company_events: (
      <Icon name="article_box_outline" size="20" color={color} />
    ),
    company_events_paper: <Icon name="globe_outline" size="20" color={color} />,
    company_policy: <Icon name="document_outline" size="20" color={color} />,
    company_absences: <Icon name="calendar_outline" size="20" color={color} />,
    company_vacations: (
      <Icon name="vkhrtek_vacations_page" size="20" color={color} />
    ),
    company_employees: <Icon name="users_3_outline" size="20" color={color} />,
    company_candidates: (
      <Icon name="user_square_on_square_outline" size="20" color={color} />
    ),
    employee_personal: (
      <Icon name="user_square_outline" size="20" color={color} />
    ),
    employee_events: (
      <Icon name="article_box_outline" size="20" color={color} />
    ),
    employee_policy: <Icon name="document_outline" size="20" color={color} />,
    employee_absences: <Icon name="calendar_outline" size="20" color={color} />,
    employee_payslips: <Icon name="wallet_outline" size="20" color={color} />,
    employee_vacations: (
      <Icon name="vkhrtek_vacations_page" size="20" color={color} />
    ),
    employee_competencies: (
      <Icon name="user_check_outline" size="20" color={color} />
    ),
    dropdown_company_settings: (
      <Icon name="gear_outline" size="20" color={color} />
    ),
    dropdown_social_services: (
      <Icon name="hand_heart_outline" size="20" color={color} />
    ),
    employee_review: (
      <Icon name="logo_vk_ads_outline" size="20" color={color} />
    ),
    company_review: <Icon name="logo_vk_ads_outline" size="20" color={color} />,
    company_settings: <Icon name="globe_outline" size="20" color={color} />,
    company_settings_account: (
      <Icon name="globe_outline" size="20" color={color} />
    ),
    company_settings_widgets_content: (
      <Icon name="globe_outline" size="20" color={color} />
    ),
    company_settings_event_types: (
      <Icon name="globe_outline" size="20" color={color} />
    ),
    company_settings_templates: (
      <Icon name="globe_outline" size="20" color={color} />
    ),
    company_settings_groups: (
      <Icon name="globe_outline" size="20" color={color} />
    ),
    company_settings_profiles: (
      <Icon name="globe_outline" size="20" color={color} />
    ),
    company_settings_substitutes: (
      <Icon name="globe_outline" size="20" color={color} />
    ),
    company_settings_vacations: (
      <Icon name="globe_outline" size="20" color={color} />
    ),
    company_settings_attorneys: (
      <Icon name="globe_outline" size="20" color={color} />
    ),
    company_settings_attorneys_users: (
      <Icon name="globe_outline" size="20" color={color} />
    ),
    company_settings_sign_types: (
      <Icon name="globe_outline" size="20" color={color} />
    ),
    company_social_news: <Icon name="globe_outline" size="20" color={color} />,
    company_services: <Icon name="globe_outline" size="20" color={color} />,
    employee_services: <Icon name="globe_outline" size="20" color={color} />,
    company_social_access: (
      <Icon name="globe_outline" size="20" color={color} />
    ),
    company_social_categories: (
      <Icon name="globe_outline" size="20" color={color} />
    ),
    company_social_quiz: <Icon name="globe_outline" size="20" color={color} />,
    company_business_trips: (
      <Icon name="plane_outline" size="20" color={color} />
    ),
    employee_business_trips: (
      <Icon name="plane_outline" size="20" color={color} />
    ),
  };
};

export const SIDEBAR_CUSTOM_ICONS = (
  isActive?: boolean,
): Record<string, JSX.Element | null> => {
  const color = isActive ? 'text.light.secondary' : 'text.light.primary';
  return {
    globe: <Icon name="globe_outline" size="20" color={color} />,
    document: <Icon name="document_outline" size="20" color={color} />,
    bookmark: <Icon name="bookmark_outline" size="20" color={color} />,
    picture: <Icon name="picture_outline" size="20" color={color} />,
    cup: <Icon name="cup_outline" size="20" color={color} />,
    briefcase: <Icon name="briefcase_outline" size="20" color={color} />,
    advertising: <Icon name="advertising_outline" size="20" color={color} />,
    user: <Icon name="user_outline" size="20" color={color} />,
    employee: <Icon name="user_outline" size="20" color={color} />,
    star: <Icon name="favorite_outline" size="20" color={color} />,
    flash: <Icon name="flash_outline" size="20" color={color} />,
    hearts: <Icon name="hearts_2_outline" size="20" color={color} />,
    info: <Icon name="info_circle_outline" size="20" color={color} />,
    notebook: <Icon name="notebook_check_outline" size="20" color={color} />,
    video: <Icon name="video_square_outline" size="20" color={color} />,
    employee_info: (
      <Icon name="vkhrtek_employee_info" size="20" color={color} />
    ),
    card: <Icon name="rectangle_info_outline" size="20" color={color} />,
    hat: <Icon name="education_outline" size="20" color={color} />,
    lightbulb: <Icon name="lightbulb_outline" size="20" color={color} />,
    thermometer: <Icon name="thermometer_outline" size="20" color={color} />,
    chain: <Icon name="chain" size="20" color={color} />,
    phone: <Icon name="phone_outline" size="20" color={color} />,
    book: <Icon name="book_spread_outline" size="20" color={color} />,
    building: <Icon name="building_outline" size="20" color={color} />,
    grid: (
      <Icon name="grid_4_uneven_vertical_outline" size="20" color={color} />
    ),
  };
};
